import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function Callback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    //console.log(
    //  'Callback useEffect Start: isAuthenticated:', auth.isAuthenticated,
    //  'isLoading:', auth.isLoading,
    //  'error:', auth.error,
    //  'user:', auth.user,
    //  'user.state:', auth.user?.state
    //);

    // The AuthProvider should have already processed the OIDC callback
    // by the time this component's useEffect runs.
    // It exchanges the code for tokens and updates the auth state (isAuthenticated, user, etc.).
    // The library also typically cleans the code/state from the URL.

    if (auth.error) {
      // If not authenticated and there's an error, it's likely from the current callback.
      if (!auth.isAuthenticated) {
        //console.error('Callback: Authentication error detected and not authenticated:', auth.error);
        navigate('/login', { replace: true, state: { error: auth.error.message } });
        return;
      }
      // If authenticated but there's an error object, it might be stale. Log it but proceed.
      //console.warn("Callback: Authenticated but auth.error is present. Proceeding with navigation to /prompt.", auth.error);
    }

    if (auth.isAuthenticated) {
      // Login.tsx passed the wanted page (path + query, e.g. a deep link from
      // an alert mail) through the OIDC state; only same-site paths are
      // honoured, everything else lands on TenderQ as before.
      const returnUrl = (auth.user?.state as { returnUrl?: string } | undefined)?.returnUrl;
      const target = returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//') && returnUrl !== '/login'
        ? returnUrl : '/tenderq';
      navigate(target, { replace: true });
    }
    // If !auth.isAuthenticated, !auth.isLoading, and no auth.error,
    // oidc-client is still processing or waiting for state change.
    // The component will show "Processing login..."

    //console.log('Callback useEffect End');
  }, [auth.isAuthenticated, auth.isLoading, auth.user, auth.error, navigate]);

  return (
    <Stack sx={{ height: "100%", justifyContent: "center", alignItems: "center", display: 'flex', flexDirection: 'column' }}><Typography>Processing login...</Typography></Stack>
  );
}

export default Callback;